const COMPANY_NAME = 'company_name';
const ADDRESS = 'address';
const ADDRESS_1 = 'address_1';
const ADDRESS_2 = 'address_2';
const ZIP_CODE = 'zip_code';
const CODE_INSEE = 'insee_code';
const CITY = 'city';
const SIREN = 'siren';
const SIRET = 'siret';
const PHONE_NUMBER = 'phone_number';
const EMAIL = 'email';
export { COMPANY_NAME, ADDRESS, ADDRESS_1, ADDRESS_2, ZIP_CODE, CODE_INSEE, CITY, SIREN, SIRET, PHONE_NUMBER, EMAIL, };
